import {connect} from 'react-redux'
import { EXPLANATION_FILTERS, applyExplanationFilter } from '../../../redux/modules/topic'
import {selectCurrentGmTopic} from '../../../redux/modules/grandmaster'
import ContentFilter from '../../../core/components/content-filter/ContentFilter'


const mapStateToProps = state => {
  const {topic} = selectCurrentGmTopic(state)
  const filtersStatuses = {}
  for (let filter in EXPLANATION_FILTERS) {
    filtersStatuses[EXPLANATION_FILTERS[filter]] = false
  }
  topic.get('explanations').forEach((e) => filtersStatuses[e.get('contentType')] = true)
  filtersStatuses['null'] = true
  return {
    activeFilter: state.getIn(['topic','explanationFilter']),
    FILTERS: EXPLANATION_FILTERS,
    filtersStatuses
  }
}
const mapDispatchToProps = dispatch => {
  return {
    applyFilter: filter => {
      dispatch(applyExplanationFilter(filter))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContentFilter)



// WEBPACK FOOTER //
// ./src/domains/grandmaster/containers/VisibleGMExplanationsFilter.js